export default {
  "content": "<path d=\"M4.22 4.2h15.56C21 4.2 22 5.19 22 6.42v11.11c0 1.24-.99 2.23-2.22 2.23H4.22A2.21 2.21 0 012 17.53v-6.66h15.56V8.64H2V6.42A2.2 2.2 0 014.22 4.2z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "fill": "#333",
    "viewBox": "0 0 24 24"
  }
};